export default "__VITE_ASSET__b7e32d42__"